/**
 * el-patio.js: the consumer rewards page. Same components as pro-circle.js
 * (earn cards, flower tickets, history table, redeem modal), but every call
 * goes to the App Proxy (/apps/petra/...), same origin, signed by Shopify.
 * Nothing here sends an email address to identify the customer.
 */
(function () {
  const cfg = window.__PATIO__ || {};
  const LOCALE = cfg.locale === 'es' ? 'es' : 'en';
  const PROXY = '/apps/petra';
  const root = document.querySelector('[data-patio]');
  if (!root) return;

  const T = {
    en: {
      next: (need, d) => `${need} more points to your next $${d} reward`,
      ready: (d) => `You can take $${d} off your next order right now`,
      pending: (p, date) => `${p} points on the way, available ${date}.`,
      noMin: 'No minimum', min: (m) => `Orders over $${m}`, pts: 'pts', more: (n) => `${n} more`,
      redeem: 'Redeem', cancel: 'Cancel', off: 'Off', points: 'Points',
      minLine: (m) => m ? `Applies to all orders over $${m}.00.` : 'No minimum order, applies to any purchase.',
      making: 'Generating your code...',
      made: (code, d, exp) => `<strong>Your discount code is ready!</strong><br><span class="ep-friend-code" style="background:#3d2c1e;color:#f4f4f2;cursor:pointer" data-copy="${code}" title="Click to copy">${code}</span><br><strong>$${d} off</strong> your next order, good until ${exp}.<br><small>It is saved in your cart drawer too, so you can apply it with one tap at checkout.</small>`,
      needMore: (need, have) => `<strong>You need ${need} more points.</strong><br>You have ${have} points. Keep earning to unlock this reward.`,
      signInRedeem: '<strong>Sign in to redeem.</strong><br>Once you are signed in, tap a flower to get your code.',
      copy: 'Copy', copied: 'Copied!', apply: 'Apply to cart', until: (d) => `until ${d}`,
      emptyHistory: 'No activity yet. Your first order starts the count.',
      types: { earn_purchase: 'Purchase', earn_third_order: 'Third Order Bonus', earn_subscription_start: 'Subscription Bonus', earn_review: 'Posted A Review', earn_join: 'Welcome Bonus', earn_birthday: 'Birthday Bonus', earn_referral: 'A Friend Ordered', redeem: 'Redeemed A Reward', refund: 'Refund', cancel: 'Cancelled Order', expire: 'Points Expired', adjust: 'Adjustment', transfer_out: 'Moved' },
      pendingTag: (d) => `pending until ${d}`,
      earn: { order: 'Place an order', join: 'Join El Patio', joined: 'Joined El Patio', review: 'Post a review', third: 'Your third order', thirdDone: 'Third order bonus claimed', sub: 'Start a subscription', birthday: 'Your birthday', birthdaySaved: 'Birthday saved', referral: 'Refer a friend', earned: 'Earned', perDollar: (n) => `+${n} pt per $1`, followIg: 'Follow us on Instagram', followTt: 'Follow us on TikTok', followedIg: 'Following on Instagram', followedTt: 'Following on TikTok' },
      followDetail: (name) => `Tap to open our ${name} in a new tab. Follow us there and the points land in your account right away.`, followBtn: (name) => `Open ${name} and claim`, followSignIn: 'Sign in to claim these points', followDone: (p) => `+${p} points added. Thank you for following along.`,
      pointsFor: (p, d) => `${p} points = $${d}`,
      subDetail: (p) => `Earn <strong>${p} bonus points</strong> the first time you start a subscription. Subscribe &amp; Save is on every Standard bottle.`,
      reviewDetail: 'Write a review of anything you have ordered and the points land within a day.',
      birthdayDetail: 'Tell us your birthday and we send you points that day.', birthdaySave: 'Save', birthdaySaved: 'Saved. We will send points on the day.', month: 'Month', day: 'Day',
      referralDetail: 'Scroll down to get your link. Your friend gets $10 off a first order of $50 or more, and you get points when it is paid.',
      shareMsg: (url) => `I use Petra Aroma's herbal body care and thought of you. This link gives you $10 off a first order of $50 or more: ${url}`,
      shareStats: (i, o) => i ? `${i} friend${i === 1 ? '' : 's'} invited, ${o} ordered.` : '',
      friendName: 'Your first name', friendEmail: 'Your email', friendErr: 'Please enter a valid email.',
      friendDone: (code, amt, min, exp) => `<p class="pc-referral-success-title">Your code is ready.</p><span class="ep-friend-code" style="background:#f4f4f2;color:#3d2c1e" data-copy="${code}">${code}</span><p style="margin:8px 0 14px;opacity:0.9">$${amt} off a first order of $${min} or more, good until ${exp}. We also sent it to your email.</p>`,
      friendGo: 'Start shopping with it applied', someone: 'Someone',
      err: 'Something went wrong. Please try again.'
    },
    es: {
      next: (need, d) => `Te faltan ${need} puntos para tu próxima recompensa de $${d}`,
      ready: (d) => `Ya puedes tomar $${d} de descuento en tu próxima orden`,
      pending: (p, date) => `${p} puntos en camino, disponibles el ${date}.`,
      noMin: 'Sin mínimo', min: (m) => `Órdenes de más de $${m}`, pts: 'pts', more: (n) => `faltan ${n}`,
      redeem: 'Canjear', cancel: 'Cancelar', off: 'de descuento', points: 'puntos',
      minLine: (m) => m ? `Aplica en órdenes de más de $${m}.00.` : 'Sin orden mínima, aplica en cualquier compra.',
      making: 'Creando tu código...',
      made: (code, d, exp) => `<strong>¡Tu código está listo!</strong><br><span class="ep-friend-code" style="background:#3d2c1e;color:#f4f4f2;cursor:pointer" data-copy="${code}" title="Toca para copiar">${code}</span><br><strong>$${d} de descuento</strong> en tu próxima orden, válido hasta el ${exp}.<br><small>También queda guardado en tu carrito, para que lo pongas con un toque al pagar.</small>`,
      needMore: (need, have) => `<strong>Te faltan ${need} puntos.</strong><br>Tienes ${have} puntos. Sigue sumando para abrir esta recompensa.`,
      signInRedeem: '<strong>Entra para canjear.</strong><br>Cuando entres, toca una flor para recibir tu código.',
      copy: 'Copiar', copied: '¡Copiado!', apply: 'Ponerlo en el carrito', until: (d) => `hasta el ${d}`,
      emptyHistory: 'Todavía no hay actividad. Tu primera orden empieza la cuenta.',
      types: { earn_purchase: 'Compra', earn_third_order: 'Bono por tercera orden', earn_subscription_start: 'Bono por suscripción', earn_review: 'Reseña publicada', earn_join: 'Bono de bienvenida', earn_birthday: 'Bono de cumpleaños', earn_referral: 'Una amiga ordenó', redeem: 'Recompensa canjeada', refund: 'Devolución', cancel: 'Orden cancelada', expire: 'Puntos vencidos', adjust: 'Ajuste', transfer_out: 'Movidos' },
      pendingTag: (d) => `pendiente hasta el ${d}`,
      earn: { order: 'Haz una orden', join: 'Entra al Patio', joined: 'Ya estás en el Patio', review: 'Escribe una reseña', third: 'Tu tercera orden', thirdDone: 'Bono de tercera orden recibido', sub: 'Empieza una suscripción', birthday: 'Tu cumpleaños', birthdaySaved: 'Cumpleaños guardado', referral: 'Invita a una amiga', earned: 'Recibido', perDollar: (n) => `+${n} pt por $1`, followIg: 'Síguenos en Instagram', followTt: 'Síguenos en TikTok', followedIg: 'Nos sigues en Instagram', followedTt: 'Nos sigues en TikTok' },
      followDetail: (name) => `Toca para abrir nuestro ${name} en otra pestaña. Síguenos allí y los puntos llegan a tu cuenta al momento.`, followBtn: (name) => `Abrir ${name} y reclamar`, followSignIn: 'Entra para reclamar estos puntos', followDone: (p) => `+${p} puntos añadidos. Gracias por seguirnos.`,
      pointsFor: (p, d) => `${p} puntos = $${d}`,
      subDetail: (p) => `Recibe <strong>${p} puntos extra</strong> la primera vez que empiezas una suscripción. Subscribe &amp; Save está en cada botella Standard.`,
      reviewDetail: 'Escribe una reseña de cualquier producto que hayas ordenado y los puntos llegan en un día.',
      birthdayDetail: 'Dinos tu cumpleaños y ese día te mandamos puntos.', birthdaySave: 'Guardar', birthdaySaved: 'Guardado. Ese día te mandamos puntos.', month: 'Mes', day: 'Día',
      referralDetail: 'Baja para tener tu enlace. Tu amiga recibe $10 de descuento en una primera orden de $50 o más, y tú recibes puntos cuando se paga.',
      shareMsg: (url) => `Yo uso los productos de Petra Aroma y me acordé de ti. Con este enlace tienes $10 de descuento en una primera orden de $50 o más: ${url}`,
      shareStats: (i, o) => i ? `${i} amiga${i === 1 ? '' : 's'} invitada${i === 1 ? '' : 's'}, ${o} ordenaron.` : '',
      friendName: 'Tu nombre', friendEmail: 'Tu correo', friendErr: 'Escribe un correo válido.',
      friendDone: (code, amt, min, exp) => `<p class="pc-referral-success-title">Tu código está listo.</p><span class="ep-friend-code" style="background:#f4f4f2;color:#3d2c1e" data-copy="${code}">${code}</span><p style="margin:8px 0 14px;opacity:0.9">$${amt} de descuento en una primera orden de $${min} o más, válido hasta el ${exp}. También te lo mandamos por correo.</p>`,
      friendGo: 'Ir a comprar con el código puesto', someone: 'Alguien',
      err: 'Algo salió mal. Inténtalo otra vez.'
    }
  }[LOCALE];

  const ICONS = {
    bottle: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="9.5" y="2" width="5" height="2.5" rx="0.3"/><path d="M8.5 4.5h7"/><path d="M9 7l-.4.6a2 2 0 0 0-.6 1.4V19a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-.6-1.4L15 7"/><path d="M12 12c-.7 1-1.2 1.9-1.2 2.7a1.2 1.2 0 0 0 2.4 0c0-.8-.5-1.7-1.2-2.7z"/></svg>`,
    one: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.5"/><path d="M10.5 9L12.5 7.5v9"/><path d="M10 16.5h5"/></svg>`,
    leaves: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21C7 15 9 10 13 7c-1 6-2.5 11-5 14z"/><path d="M16 21c1-6-1-11-5-14 1 6 2.5 11 5 14z"/><path d="M11.5 14h1"/></svg>`,
    three: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="12" r="2.8"/><circle cx="12" cy="12" r="2.8"/><circle cx="18.5" cy="12" r="2.8"/></svg>`,
    cycle: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 12a8.5 8.5 0 1 1-2.7-6.2"/><path d="M20.5 3.5v4.5h-4.5"/><path d="M12 12c-.6.8-1 1.5-1 2.2a1 1 0 0 0 2 0c0-.7-.4-1.4-1-2.2z"/></svg>`,
    star: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 3 14.4 9 20.8 9.5 15.9 14 17.4 20.5 12 17 6.6 20.5 8.1 14 3.2 9.5 9.6 9"/></svg>`,
    cake: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16"/><path d="M5 20v-6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6"/><path d="M5 15.5c1 .8 2 .8 3 0s2-.8 3 0 2 .8 3 0 2-.8 3 0 1.5.6 2 .5"/><path d="M12 12V8"/><path d="M12 8c-1-.8-1-2 0-3 1 1 1 2.2 0 3z"/></svg>`,
    flower: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="2.2"/><path d="M12 9.8c-1.6-2.2-1.2-5.3 0-6.3 1.2 1 1.6 4.1 0 6.3z"/><path d="M12 14.2c1.6 2.2 1.2 5.3 0 6.3-1.2-1-1.6-4.1 0-6.3z"/><path d="M9.8 12c-2.2 1.6-5.3 1.2-6.3 0 1-1.2 4.1-1.6 6.3 0z"/><path d="M14.2 12c2.2-1.6 5.3-1.2 6.3 0-1 1.2-4.1 1.6-6.3 0z"/></svg>`,
    camera: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r="0.6"/></svg>`,
    note: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.6 2.6 2.4 4.2 5 4.5"/></svg>`
  };

  const FLOWER_SVG = `
    <svg class="pc-flower-svg" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g class="pc-flower-border"><circle cx="110" cy="58" r="61"/><circle cx="60" cy="94" r="61"/><circle cx="79" cy="152" r="61"/><circle cx="141" cy="152" r="61"/><circle cx="160" cy="94" r="61"/></g>
      <g class="pc-flower-fill"><circle cx="110" cy="58" r="58"/><circle cx="60" cy="94" r="58"/><circle cx="79" cy="152" r="58"/><circle cx="141" cy="152" r="58"/><circle cx="160" cy="94" r="58"/></g>
    </svg>`;

  const $ = (sel, el) => (el || root).querySelector(sel);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fmtDate = (v) => {
    if (!v) return '';
    const d = new Date(typeof v === 'string' && v.length === 10 ? v + 'T12:00:00' : v);
    if (isNaN(d)) return '';
    return d.toLocaleDateString(LOCALE === 'es' ? 'es-PR' : 'en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };
  const money = (n) => Number.isInteger(Number(n)) ? String(n) : Number(n).toFixed(2);
  const show = (el) => { if (el) el.classList.remove('pc-hidden'); };
  const hide = (el) => { if (el) el.classList.add('pc-hidden'); };

  async function api(path, opts) {
    const url = `${PROXY}${path}${path.includes('?') ? '&' : '?'}locale=${LOCALE}`;
    const res = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}));
    let data = {};
    try { data = await res.json(); } catch (e) { data = {}; }
    if (!res.ok) throw new Error(data.error || T.err);
    return data;
  }

  let _config = null;
  let _member = null;

  // ── Member card ──────────────────────────────────────────────────────────

  function renderMember() {
    hide($('#ep-loading'));
    const card = $('#ep-member');
    if (!card) return;
    if (!_member) { show($('#ep-empty')); return; }
    const m = _member;
    const steps = _config.redemption_steps || [];
    const nameEl = $('[data-first-name]');
    if (nameEl && m.first_name) nameEl.textContent = m.first_name;
    $('[data-points]').textContent = Number(m.points || 0).toLocaleString();

    if (m.points > 0 && m.points_expires_at) { $('[data-expiry-date]').textContent = fmtDate(m.points_expires_at); show($('[data-expiry]')); }
    const pend = $('[data-pending]');
    if (m.pending_points > 0) { pend.textContent = T.pending(m.pending_points, fmtDate(m.pending_available_at)); show(pend); }

    const next = m.next_step;
    const affordable = steps.filter(s => s.pts <= m.points);
    const prog = $('[data-progress]');
    if (prog) {
      if (affordable.length && !next) {
        $('[data-progress-from]').textContent = T.ready(money(affordable[affordable.length - 1].dollars));
        $('[data-progress-to]').textContent = '';
        $('[data-fill]').style.width = '100%';
      } else if (next) {
        const prev = steps[steps.indexOf(next) - 1] ? steps[steps.indexOf(next) - 1].pts : 0;
        $('[data-progress-from]').textContent = affordable.length ? T.ready(money(affordable[affordable.length - 1].dollars)) : `${m.points} ${T.pts}`;
        $('[data-progress-to]').textContent = T.next(next.pts - m.points, money(next.dollars));
        $('[data-fill]').style.width = `${Math.min(100, Math.max(3, ((m.points - prev) / Math.max(1, next.pts - prev)) * 100))}%`;
      }
      show(prog);
    }
    renderCodes();
    renderHistory(m.history || []);
    show(card);
  }

  function renderCodes() {
    const wrap = $('[data-codes]'); const list = $('[data-codes-list]');
    if (!wrap || !list) return;
    const codes = (_member && _member.available_codes) || [];
    if (!codes.length) { hide(wrap); return; }
    list.innerHTML = codes.map(c => `
      <div class="ep-code">
        <span><code>${esc(c.code)}</code><small>$${money(c.dollars)} ${T.off}${c.min_order ? ` · ${esc(T.min(c.min_order))}` : ''} · ${esc(T.until(fmtDate(c.expires_at)))}</small></span>
        <span class="ep-code-actions">
          <button type="button" class="pc-btn pc-btn-dark" data-copy="${esc(c.code)}">${T.copy}</button>
          <a class="pc-btn pc-btn-dark" href="/discount/${encodeURIComponent(c.code)}?redirect=${encodeURIComponent(LOCALE === 'es' ? '/es/cart' : '/cart')}">${T.apply}</a>
        </span>
      </div>`).join('');
    show(wrap);
  }

  const HISTORY_INITIAL = 5;
  function renderHistory(rows) {
    const wrap = $('[data-history]'); const tbody = $('[data-history-rows]'); const moreBtn = $('[data-history-more]');
    if (!wrap || !tbody) return;
    if (!rows.length) { tbody.innerHTML = `<div class="pc-history-empty">${esc(T.emptyHistory)}</div>`; hide(moreBtn); show(wrap); return; }
    const rowHtml = (r) => {
      const pts = Number(r.points) || 0;
      const sign = pts > 0 ? '+ ' : pts < 0 ? '− ' : '';
      const cls = pts > 0 ? 'is-earn' : 'is-redeem';
      let codeHtml = '';
      if (r.discount_code) {
        codeHtml = `<div class="pc-history-code ${r.discount_code_active ? 'is-active' : 'is-expired'}" role="cell">
          <span class="pc-history-code-value">${esc(r.discount_code)}</span>
          <button type="button" class="pc-history-code-copy" data-copy="${esc(r.discount_code)}">${T.copy}</button>
          <span class="pc-history-code-exp">${r.discount_code_active ? esc(T.until(fmtDate(r.discount_code_expires_at))) : ''}</span></div>`;
      }
      const label = (T.types[r.type] || r.type) + (r.order_name ? ` ${esc(r.order_name)}` : '') + (r.status === 'pending' ? ` (${esc(T.pendingTag(fmtDate(r.available_at)))})` : '');
      return `<div class="pc-history-row${codeHtml ? ' has-code' : ''}" role="row" ${r.status === 'pending' ? 'style="opacity:0.65"' : ''}>
        <div class="pc-history-activity" role="cell">${label}</div>
        <div class="pc-history-points ${cls}" role="cell">${sign}${Math.abs(pts).toLocaleString()} ${T.points}</div>
        <div class="pc-history-date" role="cell">${esc(fmtDate(r.created_at))}</div>${codeHtml}</div>`;
    };
    let expanded = false;
    const paint = () => {
      tbody.innerHTML = (expanded ? rows : rows.slice(0, HISTORY_INITIAL)).map(rowHtml).join('');
      if (moreBtn) { if (rows.length > HISTORY_INITIAL && !expanded) show(moreBtn); else hide(moreBtn); }
    };
    paint();
    if (moreBtn && !moreBtn.dataset.bound) { moreBtn.dataset.bound = '1'; moreBtn.addEventListener('click', () => { expanded = true; paint(); }); }
    show(wrap);
  }

  // ── Earn cards ───────────────────────────────────────────────────────────

  function renderEarn() {
    const grid = $('[data-earn-grid]');
    if (!grid || !_config) return;
    const r = _config.earning_rules || {};
    const ref = _config.referral || {};
    const m = _member;
    const has = (type) => !!(m && (m.history || []).some(h => h.type === type));
    const items = [
      { icon: ICONS.bottle, pts: T.earn.perDollar(r.per_dollar || 1), label: T.earn.order, action: { type: 'link', url: cfg.shopUrl } },
      has('earn_join') ? { icon: ICONS.one, pts: T.earn.earned, label: T.earn.joined, earned: true }
                       : { icon: ICONS.one, pts: `+${r.join || 0} ${T.pts}`, label: T.earn.join, action: cfg.signedIn ? null : { type: 'link', url: cfg.loginUrl } },
      { icon: ICONS.leaves, pts: `+${ref.referrer_points || 0} ${T.pts}`, label: T.earn.referral, action: { type: 'detail', text: T.referralDetail } },
      has('earn_third_order') ? { icon: ICONS.three, pts: T.earn.earned, label: T.earn.thirdDone, earned: true }
                              : { icon: ICONS.three, pts: `+${r.third_order || 0} ${T.pts}`, label: T.earn.third, action: { type: 'link', url: cfg.shopUrl } },
      { icon: ICONS.star, pts: `+${r.review || 0} ${T.pts}`, label: T.earn.review, action: { type: 'detail', text: `${T.reviewDetail} <a href="${esc(cfg.reviewUrl)}" style="color:#3d2c1e;font-weight:600">→</a>` } },
      has('earn_subscription_start') ? { icon: ICONS.cycle, pts: T.earn.earned, label: T.earn.sub, earned: true }
                                     : { icon: ICONS.cycle, pts: `+${r.subscription_start || 0} ${T.pts}`, label: T.earn.sub, action: { type: 'detail', text: T.subDetail(r.subscription_start || 0) } },
      (m && m.birthday) ? { icon: ICONS.cake, pts: `+${r.birthday || 0} ${T.pts}`, label: T.earn.birthdaySaved, earned: true }
                        : { icon: ICONS.cake, pts: `+${r.birthday || 0} ${T.pts}`, label: T.earn.birthday, action: { type: 'birthday' } },
      has('earn_follow_instagram') ? { icon: ICONS.camera, pts: T.earn.earned, label: T.earn.followedIg, earned: true }
                                   : { icon: ICONS.camera, pts: `+${r.follow_instagram || 0} ${T.pts}`, label: T.earn.followIg, action: { type: 'follow', network: 'instagram', name: 'Instagram', url: 'https://www.instagram.com/petraaroma/' } },
      has('earn_follow_tiktok') ? { icon: ICONS.note, pts: T.earn.earned, label: T.earn.followedTt, earned: true }
                                : { icon: ICONS.note, pts: `+${r.follow_tiktok || 0} ${T.pts}`, label: T.earn.followTt, action: { type: 'follow', network: 'tiktok', name: 'TikTok', url: 'https://www.tiktok.com/@petraaroma' } }
    ].filter(i => !/^\+0 /.test(i.pts));

    const onclick = (item, i) => {
      if (!item.action) return '';
      if (item.action.type === 'link') return `onclick="window.location.href='${esc(item.action.url)}'"`;
      return `data-toggle="${i}"`;
    };
    grid.innerHTML = items.map((item, i) => `
      <div class="pc-earn-item${item.action ? '' : ' pc-earn-item-noclick'}${item.earned ? ' pc-earn-item-earned' : ''}" data-index="${i}" ${onclick(item, i)}>
        ${item.icon}
        <div class="pc-earn-label">${esc(item.label)}</div>
        <div class="pc-earn-pts">${esc(item.pts)}</div>
        ${item.earned ? '<span class="pc-earn-check" aria-hidden="true">✓</span>' : (item.action ? '<span class="pc-earn-arrow">&#8594;</span>' : '')}
      </div>`).join('');
    // Detail panels live in their own box under the grid (not inside it), so
    // the phone layout can turn the grid into a sideways strip.
    const details = $('[data-earn-details]');
    if (details) details.innerHTML = items.map((item, i) => {
      if (!item.action || item.action.type === 'link') return '';
      let body = item.action.type === 'birthday' ? birthdayForm()
        : item.action.type === 'follow' ? followPanel(item.action)
        : item.action.text;
      return `<div class="pc-earn-detail" id="ep-earn-detail-${i}">${body}</div>`;
    }).join('');
  }

  function followPanel(a) {
    if (!cfg.signedIn) return `<p>${esc(T.followSignIn)} <a href="${esc(cfg.loginUrl)}" style="color:#3d2c1e;font-weight:600">→</a></p>`;
    return `<div class="pc-signup-form"><p class="pc-signup-text">${esc(T.followDetail(a.name))}</p>
      <a class="pc-btn pc-btn-dark" href="${esc(a.url)}" target="_blank" rel="noopener" data-follow="${esc(a.network)}">${esc(T.followBtn(a.name))}</a>
      <p class="pc-signup-msg" data-follow-msg="${esc(a.network)}"></p></div>`;
  }

  async function claimFollow(network) {
    const msg = $(`[data-follow-msg="${network}"]`);
    try {
      const data = await api('/follow', { method: 'POST', body: JSON.stringify({ network }) });
      if (msg) msg.textContent = data.awarded ? T.followDone(data.awarded) : T.earn.earned;
      setTimeout(() => load().catch(() => {}), 2500);
    } catch (e) { if (msg) msg.textContent = e.message; }
  }

  function birthdayForm() {
    if (!cfg.signedIn) return `<p>${esc(T.birthdayDetail)} <a href="${esc(cfg.loginUrl)}" style="color:#3d2c1e;font-weight:600">${LOCALE === 'es' ? 'Entra' : 'Sign in'} →</a></p>`;
    const months = LOCALE === 'es'
      ? ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `<p class="pc-signup-text" style="margin-bottom:12px">${esc(T.birthdayDetail)}</p>
      <form class="ep-birthday" data-birthday-form>
        <select name="month" required><option value="">${T.month}</option>${months.map((n, i) => `<option value="${i + 1}">${n}</option>`).join('')}</select>
        <select name="day" required><option value="">${T.day}</option>${Array.from({ length: 31 }, (_, i) => `<option value="${i + 1}">${i + 1}</option>`).join('')}</select>
        <button type="submit" class="pc-btn pc-btn-dark">${T.birthdaySave}</button>
      </form><p class="pc-signup-msg" data-birthday-msg></p>`;
  }

  function toggleDetail(i) {
    const detail = $(`#ep-earn-detail-${i}`); const card = $(`.pc-earn-item[data-index="${i}"]`);
    if (!detail || !card) return;
    const open = detail.classList.contains('visible');
    root.querySelectorAll('.pc-earn-detail').forEach(d => d.classList.remove('visible'));
    root.querySelectorAll('.pc-earn-item').forEach(c => c.classList.remove('active'));
    if (!open) { detail.classList.add('visible'); card.classList.add('active'); detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
  }

  // ── Reward flowers ───────────────────────────────────────────────────────

  function renderTickets() {
    const grid = $('[data-tickets]');
    if (!grid || !_config) return;
    const steps = _config.redemption_steps || [];
    const pts = Number(_member ? _member.points : 0);
    grid.innerHTML = steps.map(s => {
      const locked = !!_member && pts < s.pts;
      return `<button type="button" class="pc-ticket${locked ? ' pc-ticket-locked' : ''}" data-redeem-step="${s.pts}" ${locked ? 'disabled' : ''} aria-label="$${money(s.dollars)}">
        <div class="pc-ticket-shape">${FLOWER_SVG}<div class="pc-ticket-amount">$${money(s.dollars)}</div></div>
        <div class="pc-ticket-pts ep-ticket-pts">${esc(T.pointsFor(s.pts, money(s.dollars)))}</div>
        <div class="pc-ticket-min">${esc(s.min_order > 0 ? T.min(s.min_order) : T.noMin)}</div>
      </button>`;
    }).join('');
  }

  function confirmModal(step) {
    return new Promise(resolve => {
      const overlay = document.createElement('div');
      overlay.className = 'pc-modal-overlay';
      overlay.innerHTML = `<div class="pc-modal" role="dialog" aria-modal="true">
        <button type="button" class="pc-modal-close" aria-label="Close">&times;</button>
        <div class="pc-modal-ticket"><div class="pc-ticket-shape">${FLOWER_SVG}<div class="pc-ticket-amount">$${money(step.dollars)}</div></div></div>
        <div class="pc-modal-title">$${money(step.dollars)} ${T.off}</div>
        <div class="pc-modal-pts">${step.pts} ${T.points}</div>
        <p class="pc-modal-min">${esc(T.minLine(step.min_order))}</p>
        <div class="pc-modal-actions">
          <button type="button" class="pc-btn pc-modal-cancel">${T.cancel}</button>
          <button type="button" class="pc-btn pc-modal-redeem">${T.redeem}</button>
        </div></div>`;
      document.body.appendChild(overlay); document.body.style.overflow = 'hidden';
      const done = (v) => { overlay.remove(); document.body.style.overflow = ''; resolve(v); };
      overlay.querySelector('.pc-modal-close').onclick = () => done(false);
      overlay.querySelector('.pc-modal-cancel').onclick = () => done(false);
      overlay.querySelector('.pc-modal-redeem').onclick = () => done(true);
      overlay.addEventListener('click', e => { if (e.target === overlay) done(false); });
    });
  }

  async function requestRedeem(pts) {
    const out = $('[data-redeem-result]');
    if (!_member) { if (out) { out.innerHTML = T.signInRedeem; show(out); } return; }
    const step = (_config.redemption_steps || []).find(s => s.pts === pts);
    if (!step) return;
    if (_member.points < pts) { if (out) { out.innerHTML = T.needMore(pts - _member.points, _member.points); show(out); } return; }
    if (!(await confirmModal(step))) return;
    if (out) { out.innerHTML = `<strong>${esc(T.making)}</strong>`; show(out); }
    try {
      const data = await api('/redeem', { method: 'POST', body: JSON.stringify({ points: pts }) });
      if (out) out.innerHTML = T.made(esc(data.code), money(data.dollars), esc(fmtDate(data.expires_at)));
      await load();
    } catch (e) {
      if (out) out.innerHTML = `<strong>${esc(e.message)}</strong>`;
    }
    if (out && out.scrollIntoView) out.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ── Share + friend offer ─────────────────────────────────────────────────

  function renderShare() {
    const block = $('[data-share-block]');
    if (!block || !_member || !_member.referral_url) return;
    const url = _member.referral_url;
    $('[data-share-url]').textContent = url;
    const msg = T.shareMsg(url);
    $('[data-share-whatsapp]').href = `https://wa.me/?text=${encodeURIComponent(msg)}`;
    $('[data-share-sms]').href = `sms:?&body=${encodeURIComponent(msg)}`;
    const stats = $('[data-share-stats]');
    const s = T.shareStats(_member.referrals.invited, _member.referrals.ordered);
    if (s) { stats.textContent = s; stats.hidden = false; }
    show(block);
  }

  async function initFriend(loaded) {
    // Liquid cannot read the query string; the ref is picked up here and kept
    // for the session so a friend who browses first still sees the offer.
    let ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) { try { sessionStorage.setItem('patio_ref', ref); } catch (e) {} }
    else { try { ref = sessionStorage.getItem('patio_ref'); } catch (e) {} }
    if (!ref || cfg.trade) return;
    const sec = $('#ep-share'); const area = $('[data-share-area]');
    if (!sec || !area) return;

    let name = T.someone;
    try { const info = await api(`/friend-offer?ref=${encodeURIComponent(ref)}`); if (info.referrer_name) name = info.referrer_name; }
    catch (e) { return; } // an invalid link just shows the normal share section

    $('[data-share-eyebrow]').textContent = $('[data-friend-eyebrow]').textContent;
    $('[data-share-title]').textContent = $('[data-friend-title]').textContent;
    $('[data-share-text]').textContent = $('[data-friend-text]').textContent.replace('{name}', name);
    area.innerHTML = `
      <form class="pc-referral-form" data-friend-form novalidate>
        <input type="text" name="website" tabindex="-1" autocomplete="off" class="ep-hp" aria-hidden="true">
        <input type="text" name="first_name" class="pc-form-input" placeholder="${esc(T.friendName)}" required autocomplete="given-name">
        <input type="email" name="email" class="pc-form-input" placeholder="${esc(T.friendEmail)}" required autocomplete="email">
        <label class="pc-referral-checkbox"><input type="checkbox" name="consent" checked><span>${esc($('[data-consent-label]').textContent)}</span></label>
        <button type="submit" class="pc-btn pc-referral-submit" data-friend-submit>${esc($('[data-friend-cta]').textContent)}</button>
        <p class="pc-referral-fineprint">${esc($('[data-friend-fineprint]').textContent)}</p>
        <p class="pc-referral-error pc-hidden" data-friend-error></p>
      </form>
      <div class="ep-friend-done pc-hidden" data-friend-done></div>`;
    // Scroll now for feedback, then re-aim: the earn grid and tickets above
    // this section render when /me returns, and the photos arrive later
    // still. Each one pushes the offer further down the page, which on a
    // phone left the first scroll short of the form.
    const goTo = (behavior) => sec.scrollIntoView({ behavior, block: 'start' });
    goTo('smooth');
    if (loaded && loaded.then) loaded.then(() => requestAnimationFrame(() => goTo('smooth'))).catch(() => {});
    if (document.readyState === 'complete') setTimeout(() => goTo('auto'), 900);
    else window.addEventListener('load', () => setTimeout(() => goTo('auto'), 150), { once: true });
    const form = $('[data-friend-form]');
    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      const err = $('[data-friend-error]'); hide(err);
      const btn = $('[data-friend-submit]');
      const email = form.email.value.trim();
      if (!email.includes('@')) { err.textContent = T.friendErr; show(err); return; }
      btn.disabled = true;
      try {
        const data = await api('/friend-claim', { method: 'POST', body: JSON.stringify({ ref, email, first_name: form.first_name.value.trim(), consent: form.consent.checked, website: form.website.value }) });
        hide(form);
        const done = $('[data-friend-done]');
        done.innerHTML = `${T.friendDone(esc(data.code), money(data.amount), money(data.min_order), esc(fmtDate(data.expires_at)))}<a class="pc-btn pc-referral-submit" href="${esc(data.redirect)}">${esc(T.friendGo)}</a>`;
        show(done);
        try { sessionStorage.removeItem('patio_ref'); history.replaceState(null, '', window.location.pathname); } catch (e) {}
      } catch (e) { err.textContent = e.message; show(err); btn.disabled = false; }
    });
  }

  // ── Wiring ───────────────────────────────────────────────────────────────

  root.addEventListener('click', (ev) => {
    const step = ev.target.closest('[data-redeem-step]');
    if (step && !step.disabled) { requestRedeem(Number(step.dataset.redeemStep)); return; }
    const tog = ev.target.closest('[data-toggle]');
    if (tog) { toggleDetail(Number(tog.dataset.toggle)); return; }
    const follow = ev.target.closest('[data-follow]');
    if (follow) { claimFollow(follow.dataset.follow); return; } // the link itself opens the profile in a new tab
    const copy = ev.target.closest('[data-copy], [data-share-copy]');
    if (copy) {
      const val = copy.dataset.copy || ($('[data-share-url]') || {}).textContent || '';
      const prev = copy.textContent;
      const ok = () => { copy.textContent = T.copied; setTimeout(() => { copy.textContent = prev; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(val).then(ok, ok);
      else { const ta = document.createElement('textarea'); ta.value = val; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} ta.remove(); ok(); }
    }
  });

  root.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('[data-birthday-form]');
    if (!form) return;
    ev.preventDefault();
    const msg = $('[data-birthday-msg]');
    try {
      await api('/birthday', { method: 'POST', body: JSON.stringify({ month: form.month.value, day: form.day.value }) });
      if (msg) msg.textContent = T.birthdaySaved;
      form.hidden = true;
      await load();
    } catch (e) { if (msg) msg.textContent = e.message; }
  });

  async function load() {
    const data = await api('/me');
    _config = data.config || {};
    _member = data.member || null;
    renderEarn();
    renderTickets();
    if (cfg.signedIn && !cfg.trade) { renderMember(); renderShare(); }
  }

  const loaded = load().catch(err => {
    console.warn('[el patio]', err.message);
    const loading = $('#ep-loading');
    if (loading) loading.textContent = err.message;
  });
  initFriend(loaded);
})();
